<script lang="ts">
    export let numberOfSkeleton: number = 12;
</script>

{#each Array(numberOfSkeleton) as item}
    <li class="col-md-4 mb-4 mr-0">
        <div class="wrapper-skeleton">
            <div class="image-skeleton background-animate" />
            <div class="desc-skeleton background-animate" />
            <div class="button-skeleton background-animate" />
        </div>
    </li>
{/each}

<style>
    .wrapper-skeleton {
        overflow: hidden;
        margin-bottom: 50px;
        padding: 7px;
    }

    .wrapper-skeleton > div {
        background-color: grey;
        margin-bottom: 10px;
    }

    .image-skeleton {
        width: 100%;
        height: 200px;
    }

    .desc-skeleton {
        width: 100%;
        height: 100px;
    }

    .button-skeleton {
        width: 100%;
        height: 30px;
    }
</style>
